// extracted by mini-css-extract-plugin
export default {"wrap":"DateCountdown_wrap__H51n3","label":"DateCountdown_label__2-4Dd","value":"DateCountdown_value__qqw2C","colon":"DateCountdown_colon__qGgbB"};